import BaseService from '@/features/BaseService';

export default class CallHistoryService extends BaseService {
  constructor() {
    super('call-histories');
  }
}



// WEBPACK FOOTER //
// ./src/features/call-histories/CallHistoryService.js